/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeSquareIcon16Light } from './ShapeSquareIcon16Light';
import { ShapeSquareIcon16Regular } from './ShapeSquareIcon16Regular';
import { ShapeSquareIcon16Solid } from './ShapeSquareIcon16Solid';
import { ShapeSquareIcon20Light } from './ShapeSquareIcon20Light';
import { ShapeSquareIcon20Regular } from './ShapeSquareIcon20Regular';
import { ShapeSquareIcon20Solid } from './ShapeSquareIcon20Solid';
import { ShapeSquareIcon24Regular } from './ShapeSquareIcon24Regular';
import { ShapeSquareIcon24Solid } from './ShapeSquareIcon24Solid';
import { ShapeSquareIcon32Regular } from './ShapeSquareIcon32Regular';
import { ShapeSquareIcon64Regular } from './ShapeSquareIcon64Regular';
var sizes = {
    16: {
        light: ShapeSquareIcon16Light,
        regular: ShapeSquareIcon16Regular,
        solid: ShapeSquareIcon16Solid,
    },
    20: {
        light: ShapeSquareIcon20Light,
        regular: ShapeSquareIcon20Regular,
        solid: ShapeSquareIcon20Solid,
    },
    24: {
        regular: ShapeSquareIcon24Regular,
        solid: ShapeSquareIcon24Solid,
    },
    32: {
        regular: ShapeSquareIcon32Regular,
    },
    64: {
        regular: ShapeSquareIcon64Regular,
    },
};
export var ShapeSquareIcon = forwardRef('ShapeSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
